import React from 'react';

import styles from './index.module.css';

const Tag = ({ children, kind, className, style }) => {
    const tags = {
        title: 'h1',
        subtitle: 'h2',
        caption: 'span',
        body: 'p',
    };

    const TagComponent = tags[kind] || 'p';

    return (
        <TagComponent className={className} style={style}>
            {children}
        </TagComponent>
    );
};

export const Text = ({ children, kind = 'body', style }) => {
    return (
        <Tag className={styles[kind]} kind={kind} style={style}>
            {children}
        </Tag>
    );
};
